import type { ConcernId } from '../core/types/catalog'

/**
 * Elk antwoord wijst naar een klacht (concerns.ts); de klacht bepaalt het protocol.
 * Alleen waar een antwoord los van de klacht een protocol kiest, staat een routineId.
 */
export type QuizOption = {
  label: string
  hint?: string
  concern?: ConcernId
  /** Kiest direct een protocol, los van de klacht. */
  routineId?: string
  /** Zwaarte in de uitslag. Standaard 1. */
  weight?: number
}

export type QuizQuestion = {
  id: string
  question: string
  intro?: string
  options: QuizOption[]
}

export const quizQuestions: QuizQuestion[] = [
  {
    id: 'concern',
    question: 'Wat stoort je op dit moment het meest?',
    intro: 'Kies waar je huid je het vaakst aan doet denken.',
    options: [
      {
        label: 'Pigmentvlekken en een onrustige teint',
        hint: 'Na de zomer, zwangerschap of de overgang',
        concern: 'pigmentatie',
        weight: 2,
      },
      {
        label: 'Onzuiverheden rond kaaklijn en kin',
        hint: 'Vaak meebewegend met je cyclus',
        concern: 'hormonaal',
        weight: 2,
      },
      {
        label: 'Roodheid en een huid die snel reageert',
        hint: 'Ook bij rosacea of couperose',
        concern: 'gevoelig',
        weight: 2,
      },
      {
        label: 'Droog en trekkerig',
        hint: 'Vooral na het wassen of in de winter',
        concern: 'droog',
        weight: 2,
      },
      {
        label: 'Doffe huid zonder glans',
        hint: 'Voelt onregelmatig aan, weinig weerkaatsing',
        concern: 'dof',
        weight: 2,
      },
      {
        label: 'Verslapping en lijntjes',
        hint: 'Minder stevigheid rond ogen, kaaklijn en wangen',
        concern: 'veroudering',
        weight: 2,
      },
    ],
  },
  {
    id: 'reaction',
    question: 'Hoe reageert je huid op nieuwe producten?',
    options: [
      { label: 'Rustig — ik verdraag vrijwel alles', weight: 0 },
      { label: 'Wisselend, soms puistjes of gloed', concern: 'hormonaal' },
      { label: 'Snel rood, trekkerig of warm', concern: 'gevoelig' },
    ],
  },
  {
    id: 'routine',
    question: 'Hoe ziet je routine er nu uit?',
    options: [
      {
        label: 'Reinigen en een crème, meer niet',
        hint: 'We houden het simpel en effectief',
        weight: 0,
      },
      { label: 'Vier tot zes producten', weight: 0 },
      {
        label: 'Een volle plank waar ik doorheen ben',
        hint: 'Tijd om terug te brengen naar wat werkt',
        weight: 0,
      },
    ],
  },
  {
    id: 'depth',
    question: 'Hoe grondig wil je het aanpakken?',
    intro:
      'Eerlijk: een halve routine geeft een half resultaat. Ik zeg liever vooraf wat het vraagt.',
    options: [
      {
        label: 'Compleet — ochtend én avond, alles erin',
        hint: 'Vijf producten, vier tot vijf maanden. Inclusief videoconsult en huidplan.',
        routineId: 'compleet-anti-ageing',
        weight: 4,
      },
      {
        label: 'Het protocol dat bij mijn klacht hoort',
        hint: 'Drie à vier producten, ongeveer drie maanden',
        weight: 0,
      },
      {
        label: 'Rustig starten, later uitbreiden',
        hint: 'Ik mail je dan ook het opbouwschema',
        weight: 0,
      },
    ],
  },
]
